const comments = [
  {
    name: '吃瓜第一线',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20illustration%20of%20a%20cool%20young%20person%20profile%2C%20warm%20coral%20and%20amber%20gradient%20circle%2C%20editorial%20flat%20vector%20style%2C%20simple%20and%20clean%2C%20modern%20social%20media%20profile%20picture&width=120&height=120&seq=avatar-01&orientation=squarish',
    time: '3分钟前',
    content: '这个瓜太大了，终于有人整理全了！之前零零散散看了好多版本，91吃瓜这里一下子全汇总了，吃得太爽了哈哈哈。收藏收藏！',
    likes: 1283,
  },
  {
    name: '八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20illustration%20of%20a%20stylish%20profile%2C%20warm%20amber%20gradient%20circle%2C%20editorial%20flat%20vector%20style%2C%20simple%20and%20clean%2C%20modern%20social%20media%20profile%20picture&width=120&height=120&seq=avatar-02&orientation=squarish',
    time: '15分钟前',
    content: '确实好用，网址导航做得太齐了，之前总是找不到最新入口，现在直接来这里看就行。更新也快，点赞小编！',
    likes: 967,
  },
  {
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20illustration%20of%20a%20trendy%20person%20profile%2C%20warm%20coral%20gradient%20circle%2C%20editorial%20flat%20vector%20style%2C%20simple%20and%20clean%2C%20modern%20social%20media%20profile%20picture&width=120&height=120&seq=avatar-03&orientation=squarish',
    time: '28分钟前',
    content: '深夜不睡就是等这个瓜的后续！91吃瓜从来不让我失望，每次打开都有新鲜热辣的内容。手机版也很流畅，通勤路上必备！',
    likes: 756,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          瓜友热评精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">吃瓜群众的真实声音</p>
        <div className="space-y-5">
          {comments.map((comment, i) => (
            <div key={i} className="bg-background-100 rounded-lg border border-background-200/70 p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
                <div className="ml-auto flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}